module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4ROgd"))).then(() => module.bundle.root('ewmtE'));